<template>
  <div>
    <div class="columns">
      <div class="column">
        <p class="title is-6 mt-2 mb-1">Line styles</p>
        <div class="up-input-group">
          <up-textinput
          v-model="line_creator.line_styles.bg_color"
          size="sm"
          label="Line Color"
          ></up-textinput>
          <up-numberinput
          v-model="line_creator.line_width"
          size="sm"
          label="Line Width"
          labelIcon="mdi mdi-alpha-w-box-outline"
          ></up-numberinput>
        </div>    
      </div>
      <div class="column">
        <style-editor
            title="Box"
            show_width 
            show_height
            v-model="line_creator.box_styles"
        ></style-editor>
      </div>
    </div>
  <div class="column is-12">
        <p class="title is-5">Line Cordinates <b-button @click="addLine()" type="is-success" size="is-small">Add line</b-button></p>
        
        <table>
          <tr>
            <th>Start Point</th>
            <th>End Point</th>
            <th>Action</th>
          </tr>
          <tr v-for="(line,line_i) in line_creator.lines_cordinates" :key="`LINE_TBL_ROW${line_i}`">
            <td>
              <div class="up-input-group">
                <up-numberinput
                v-model="line.start.x"
                size="sm"
                labelIcon="mdi mdi-alpha-x-box-outline"
                ></up-numberinput>
                <up-numberinput
                v-model="line.start.y"
                size="sm"
                labelIcon="mdi mdi-alpha-y-box-outline"
                ></up-numberinput>
              </div>
            </td>
            <td>    
              <div class="up-input-group">
                <up-numberinput
                v-model="line.end.x"
                size="sm"
                labelIcon="mdi mdi-alpha-x-box-outline"
                ></up-numberinput>
                <up-numberinput
                v-model="line.end.y"
                size="sm"
                labelIcon="mdi mdi-alpha-y-box-outline"
                ></up-numberinput>
              </div>
            </td>    
            <td label="Action">
              <b-button @click="removeLine(line_i)" type="is-danger" icon-left="close"></b-button>
            </td>
          </tr>
        </table>  
    </div>
    <show-line-creator :line_creator="line_creator"></show-line-creator>
  </div>
</template>

<script>

import { defaultLineCreatorValue } from "./utils";
import ShowLineCreator from '@/components/Question/LineCreator/ShowLineCreator';
import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpNumberinput from '@/components/UI/Inputs/UpNumberinput'
import StyleEditor from '@/components/Common/StyleEditor/StyleEditor'

export default {
  name: "set-line-creator",
  props: {
    value: {
      type: Object,
    },
  },
  components: {
    ShowLineCreator,
    UpTextinput,
    UpNumberinput,
    StyleEditor,
  },
  data() {
    return {
      line_creator: this.value ? this.value : defaultLineCreatorValue(),
    };
  },
  methods:{
    addLine(){
      this.line_creator.lines_cordinates.push({
        start :{ x : 0, y : 0},
        end :{ x : 0, y : 0},
      })
    },
    removeLine(i){
      this.line_creator.lines_cordinates.splice(i, 1)
    },
  },
  watch: {
    line_creator: {
      handler: function (new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function (new_val) {
        this.line_creator = new_val;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
</style>